<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle">Table of Contents</h1><p class="left"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="left"><a href="#/toc">Table of Contents</a></p>
<p class="left"><a href="#/front01">Copyright</a></p>
<p class="left"><a href="#/front02">Epigraph</a></p>
<p class="left"><a href="#/c01">1. Playback</a></p>
<p class="left"><a href="#/c02">2. Strawberry Park</a></p>
<p class="left"><span href="#/c03" title="Link target outside of Sample">3. The State of Water</span></p>
<p class="left"><span href="#/c04" title="Link target outside of Sample">4. Geronimo</span></p>
<p class="left"><span href="#/c05" title="Link target outside of Sample">5. Quit</span></p>
<p class="left"><span href="#/c06" title="Link target outside of Sample">6. God's Goose </span></p>
<p class="left"><span href="#/c07" title="Link target outside of Sample">7. Mount Saint Scholastica</span></p>
<p class="left"><span href="#/c08" title="Link target outside of Sample">8. Bad Penny</span></p>
<p class="left"><span href="#/c09" title="Link target outside of Sample">9. If the Creek Don't Rise</span></p>
<p class="left"><span href="#/c10" title="Link target outside of Sample">10. Whiteman </span></p>
<p class="left"><span href="#/c11" title="Link target outside of Sample">11. BVM</span></p>
<p class="left"><span href="#/back01" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2736abee